import * as React from 'react';
import getUrlInfo from '../../../services/mini/getUrlInfo';

function OfflineBanner() {

    const { projectName } = getUrlInfo();

    return (
        <div className={`offline-panel`}>
            <i className="icon icon-alan-info-sign" />
            You are offline. {projectName ?
                <>All of the changes you make will be lost, please restore your connection and resume
                    working with Alan AI Studio.</> :
                <>Please restore your connection and resume
                    working with Alan AI Studio.</>
            }
        </div>
    );
}

export default OfflineBanner;